// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-71ddbd8a]{border:1px solid #f4f4f4;border-radius:10px}.menu-item[data-v-71ddbd8a]{flex-wrap:nowrap;padding:.75rem;transition:opacity .2s;width:100%}.menu-item[data-v-71ddbd8a]:not(.nuxt-link-active):hover{color:#49494f}.icon-container[data-v-71ddbd8a]{flex-shrink:0;width:50px}.icon-container img[data-v-71ddbd8a]{vertical-align:middle}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
